export default __webpack_public_path__ + "static/media/IconPhone.a0a5b3db.svg";